import {
    EnumCommandOutcome,
    getBadgeVariantByCommandOutcome,
    getEnumCommandOutcomeLabel,
    type ApiCommandAuditLog,
} from '@Model';
import { Badge, Column } from '@synqo/frontend-component-library';

export const commandAuditLogColumns: Column<ApiCommandAuditLog>[] = [
    { name: 'created_at', label: 'Zeitpunkt', type: 'datetime' },
    { name: 'name', label: 'Command' },
    {
        name: 'outcome',
        label: 'Outcome',
        renderCell: ({ cellData }) => {
            const outcome = cellData as EnumCommandOutcome;
            return (
                <Badge variant={getBadgeVariantByCommandOutcome(outcome)}>{getEnumCommandOutcomeLabel(outcome)}</Badge>
            );
        },
    },
    { name: 'invocation_id', label: 'Command-ID' },
    { name: 'created_by', label: 'Benutzer-ID' },
];
